module.exports = __webpack_public_path__ + "img/not-found-search.476ef8b4.png";